module.exports = __webpack_public_path__ + "static/media/self-managed-page.525568a0.png";